const experience = [
    {
        id: "kadree",
        role: "Ingeniero Senior",
        company: "Kadree Tech",
        location: "Colombia (remoto)",
        period: "Abril 2021 – Presente",
        bullets: [
            "Desarrollo de sistemas financieros y de monitoreo con .NET Core, Spring Boot, Angular, Kafka, Redis y Docker.",
            "Implementación de arquitectura limpia orientada a DDD, pruebas unitarias e integración con AWS (SQS, S3, EC2).",
            "Lenguajes principales: C#, Java, TypeScript y JavaScript.",
        ],
    },
    {
        id: "factech",
        role: "Desarrollador Full Stack",
        company: "Factech Servicios Informáticos",
        location: "España (remoto)",
        period: "Febrero 2024 – Enero 2025",
        bullets: [
            "Mantenimiento y evolución de sistemas geoespaciales existentes.",
            "Desarrollo de Web APIs, consolas y frontends Angular con GeoServer.",
            "Bases de datos Oracle, PostgreSQL y datos geoespaciales.",
        ],
    },
    {
        id: "hublance",
        role: "Consultant .NET Developer",
        company: "Hublance",
        location: "España (remoto)",
        period: "Marzo 2022 – Febrero 2024",
        bullets: [
            "Mantenimiento de sistemas geoespaciales y desarrollo de Web APIs y consolas.",
            "Integración frontend Angular y servicios geoespaciales (GeoServer).",
            "Trabajo con Oracle, PostgreSQL y bases de datos geoespaciales.",
        ],
    },
    {
        id: "innovasoft",
        role: "Desarrollador de Software",
        company: "InnovaSoft Class",
        location: "Costa Rica (remoto)",
        period: "Febrero 2020 – Abril 2021",
        bullets: [
            "Mantenimiento de sistemas académicos y contables.",
            "Desarrollo con .NET, WCF, C#, VB, JavaScript, CSS, jQuery y Reporting Services.",
            "Transact-SQL, manuales de usuario/pruebas y atención de bitácoras.",
        ],
    },
    {
        id: "dgi",
        role: "Analista de Sistemas",
        company: "Dirección General de Ingresos (DGI)",
        location: "Nicaragua",
        period: "Diciembre 2014 – Febrero 2020",
        bullets: [
            "Mantenimiento de sistemas tributarios, administrativos, de riesgos y de gestiones.",
            "Desarrollo en C#, PHP, .NET, WCF y .NET Core (sistemas y consolas).",
        ],
    },
];

export default experience;
